<template>
  <div class="QuantitySelector">
    <button
      class="QuantitySelector_btn"
      :class="{ disabled: quantity <= min || diabledQuantitySelector }"
      @click="decrease">
      <app-icon name="minus" />
    </button>

    <span class="QuantitySelector_text">
      {{ quantity }}
    </span>

    <button
      class="QuantitySelector_btn"
      :class="{ disabled: diabledQuantitySelector }"
      @click="increase">
      <app-icon name="plus" />
    </button>
  </div>
</template>

<script>
  export default {
    name: 'app-quantity-selector',

    props: {
      min: {
        type: Number,
        default: 1
      },
      quantity: {
        type: Number,
        default: 1
      },
      diabledQuantitySelector: {
        type: Boolean,
        default: false
      },
      bundleName: {
        type: String,
        default: null
      },
      ctn: {
        type: String,
        default: ''
      }
    },

    methods: {
      increase () {
        this.updateQuantity(this.quantity + 1)
        this.trackConversion({
          name: 'interaction',
          description: `${this.ctn}:${this.quantity + 1}:quantity:increase`
        })
      },

      decrease () {
        this.updateQuantity(this.quantity - 1)
        this.trackConversion({
          name: 'interaction',
          description: `${this.ctn}:${this.quantity - 1}:quantity:decrease`
        })
      },

      updateQuantity (quantity) {
        this.$emit('update-quantity', quantity)
      }
    }
  }
</script>

<style lang="scss">
  .QuantitySelector {
    display: none;
    align-items: center;
    justify-content: space-between;
    width: 1.2rem;

    @include media(tablet) {
      width: .96rem;
    }

    &_btn {
      &.disabled {
        pointer-events: none;
        opacity: 0.5;
      }

      .icon {
        width: .4rem;
        height: .4rem;

        @include media(tablet) {
          width: .32rem;
          height: .32rem;
        }
      }
    }

    &_text {
      color: #212121;
      font-size: .16rem;
      font-weight: 400;
    }
  }
</style>
